import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import { Fade, SelectChangeEvent } from '@mui/material';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { colors } from '../../../theme';
import { DataSetProps } from '../../Charts/chartsInterfaces';
import LineChart from '../../Charts/lineChart';
import { MenuItemStyled, SelectFilterStyled } from '../../Dashboard/TemporalScope/TemporalScopeSelect/styled';
import { GetHistoricalProps, HistoricalTemporalityOption } from '../../HotAlerts/hotAlertsInterface';
import Title from '../../Title/title';
import { BigBoxModalStyled } from '../styled';
import { CloseIconModalStyled, LineChartModalHeaderStyled, ModalStyled, TemporalitySelectFormControlStyled } from './styled';

interface LineChartModalInterface {
    handleClose: () => void;
    openModal: boolean
    title: string
    historical: GetHistoricalProps
    temporalityOptions: HistoricalTemporalityOption[]
    selectedTemporality: string
    handleChangeTemporality: (temporality: string) => void
}

const LineChartModal: FC<LineChartModalInterface> = ({ handleClose, openModal, title, historical, temporalityOptions, selectedTemporality, handleChangeTemporality }) => {
    const { t } = useTranslation('hotAlerts');
    const MAX_OF_ITEMS = 12;

    const dataSets: DataSetProps[] = historical && [
        {
            label: t('summary.numberOfHotAlerts'),
            data: historical.hotAlertCounts.slice(-MAX_OF_ITEMS),
            fill: false,
            borderColor: colors.grey400,
            fillColor: colors.grey400,
            backgroundColor: colors.grey400,
            tension: 0.1,
        },
        {
            label: t('summary.numberOfHotAlertsToTreat'),
            data: historical.toTreatHotAlertCounts.slice(-MAX_OF_ITEMS),
            fill: false,
            borderColor: colors.default2,
            fillColor: colors.default2,
            backgroundColor: colors.default2,
            tension: 0.1,
        },
    ];

    const handleChange = (event: SelectChangeEvent<unknown>) => {
        handleChangeTemporality(String(event.target.value));
    };

    return (
        <ModalStyled
            aria-describedby="modal-modal-description"
            aria-labelledby="modal-modal-title"
            onClose={handleClose}
            open={openModal}
        >
            <Fade in={openModal}>
                <BigBoxModalStyled height='auto' maxWidth='900px' width='80%'>
                    <LineChartModalHeaderStyled>
                        <Title content={title} modalTitle />
                        {temporalityOptions.length > 0 && (
                            <TemporalitySelectFormControlStyled>
                                <SelectFilterStyled
                                    IconComponent={ArrowDropDownRoundedIcon}
                                    onChange={handleChange}
                                    sx={{ color: colors.grey100 }}
                                    value={selectedTemporality}
                                    variant="standard"
                                >
                                    {temporalityOptions.map((option) => (
                                        <MenuItemStyled
                                            key={option.value}
                                            value={option.value}
                                            disableRipple
                                        >
                                            {option.label}
                                        </MenuItemStyled>
                                    ))}
                                </SelectFilterStyled>
                            </TemporalitySelectFormControlStyled>
                        )}
                    </LineChartModalHeaderStyled>
                    <CloseIconModalStyled onClick={handleClose} />
                    {historical && (
                        <LineChart
                            datasets={dataSets}
                            labels={historical.modalities.slice(-MAX_OF_ITEMS)}
                        />
                    )}
                </BigBoxModalStyled>
            </Fade>
        </ModalStyled>
    );
};

export default LineChartModal;
